export var TranslationsKeys;
(function (TranslationsKeys) {
    TranslationsKeys["TITLE"] = "adminSection.system.statusPortal.name";
    TranslationsKeys["SUBTITLE"] = "statusPortal.subtitle";
    TranslationsKeys["LABEL"] = "statusPortal.label";
    TranslationsKeys["LABEL_CLICK_HERE"] = "statusPortal.clickHere";
})(TranslationsKeys || (TranslationsKeys = {}));
//# sourceMappingURL=constants.js.map